var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2945 31.0093L35.0057 21.3024L44.7209 31.0172L50.3684 25.366L35.0057 10L19.6431 25.362L25.2945 31.0093Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35.0007L15.6493 29.3516L21.2987 35.0007L15.6493 40.6498L10 35.0007Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2936 38.9908L35.0048 48.7016L44.72 38.9868L50.3714 44.6301L50.3675 44.634L35.0048 60L19.6422 44.6419L19.6343 44.634L25.2936 38.9908Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7012 35.002L54.3505 29.3528L59.9999 35.002L54.3505 40.6511L48.7012 35.002Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7353 34.998L35.0049 29.2639L30.7673 33.5013L30.2776 33.9871L29.2745 34.9901L29.2666 34.998L29.2745 35.0099L35.0049 40.7361L40.7353 35.002L40.7392 34.998H40.7353Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.cc9fa410f9b3a3efa212b07a6c56b256.svg";
export { ForwardRef as ReactComponent };